import React from 'react';
import './primaryButton.css';
import { Link } from 'react-router-dom';

const PrimaryButton = ({ text, icon: Icon, linkTo, onClick, type = 'button', disabled = false }) => {
    const content = (
        <>
            {text}
            {Icon && <Icon className="icon" />}
        </>
    );

    if (linkTo) {
        return (
            <Link to={linkTo} className="primary-button" onClick={onClick}>
                {content}
            </Link>
        );
    }

    return (
        <button
            type={type}
            className="primary-button"
            onClick={onClick}
            disabled={disabled}
        >
            {content}
        </button>
    );
};

export default PrimaryButton;
